module.exports = __webpack_public_path__ + "static/media/libaray.df46dff6.png";